(function () {
  if (window.EyesnugDeferredReviewWidget) {
    window.EyesnugDeferredReviewWidget.init(document);
    return;
  }

  var observers = {};
  var manifests = {};
  var reviewScrollFrame = null;
  var reviewScrollSettleTimer = null;
  var reviewScrollRequested = false;

  function restoreScripts(fragment) {
    fragment.querySelectorAll('script').forEach(function (script) {
      var replacement = document.createElement('script');
      Array.prototype.slice.call(script.attributes).forEach(function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      replacement.textContent = script.textContent;
      script.replaceWith(replacement);
    });
  }

  function reviewAssetBase() {
    var loader = document.querySelector(
      'script[src*="/judgeme-"][src$="/loader.js"], script[src*="judgeme"][src$="/loader.js"]'
    );
    return loader ? new URL('.', loader.src).href : '';
  }

  function loadEntryStyles(baseUrl, entryKey) {
    // The extension URL contains its version. Reuse its manifest across the
    // carousel and full reviews, including when both activate together.
    if (!manifests[baseUrl]) {
      manifests[baseUrl] = fetch(baseUrl + 'manifest.json')
        .then(function (response) {
          if (!response.ok) throw new Error('Judge.me manifest request failed');
          return response.json();
        })
        .catch(function (error) {
          delete manifests[baseUrl];
          throw error;
        });
    }

    return manifests[baseUrl].then(function (manifest) {
        var visited = {};

        function loadManifestEntry(key) {
          if (!key || visited[key] || !manifest[key]) return;
          visited[key] = true;

          var entry = manifest[key];
          (entry.css || []).forEach(function (stylesheet) {
            var source = baseUrl + stylesheet;
            if (document.querySelector('link[href="' + source + '"]')) return;

            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = source;
            document.head.appendChild(link);
          });
          (entry.imports || []).forEach(loadManifestEntry);
        }

        loadManifestEntry(entryKey);
      });
  }

  function loadReviewEntry(container) {
    var widget = container.querySelector('[data-entry-point][data-entry-key]');
    var baseUrl = reviewAssetBase();
    if (!widget || !baseUrl) return Promise.resolve();

    var moduleSource = baseUrl + widget.getAttribute('data-entry-point');
    if (document.querySelector('script[src="' + moduleSource + '"]')) return Promise.resolve();

    return loadEntryStyles(baseUrl, widget.getAttribute('data-entry-key'))
      .catch(function () {
        // The module still gets a chance to render if the optional manifest request fails.
      })
      .then(function () {
        return new Promise(function (resolve) {
          var script = document.createElement('script');
          script.type = 'module';
          script.src = moduleSource;
          script.onload = resolve;
          script.onerror = resolve;
          document.head.appendChild(script);
        });
      });
  }

  function activate(container) {
    if (!container || container.getAttribute('data-eyesnug-review-state')) return;

    var template = container.querySelector('[data-eyesnug-deferred-review-template]');
    if (!template) return;

    container.setAttribute('data-eyesnug-review-state', 'loading');
    var fragment = template.content.cloneNode(true);
    restoreScripts(fragment);

    var placeholder = container.querySelector('[data-eyesnug-deferred-review-placeholder]');
    if (placeholder) placeholder.remove();
    template.remove();
    container.appendChild(fragment);
    loadReviewEntry(container).then(function () {
      container.setAttribute('aria-busy', 'false');
      container.setAttribute('data-eyesnug-review-state', 'ready');
      settleReviewScroll();
    });
  }

  function activateAll() {
    document.querySelectorAll('[data-eyesnug-deferred-review-widget]').forEach(activate);
  }

  function reviewScrollTarget() {
    return document.getElementById('judgeme_product_reviews') ||
      document.querySelector('[data-eyesnug-deferred-review-widget]');
  }

  function scrollToReviews() {
    var target = reviewScrollTarget();
    if (!target) return;

    var stickyHeader = document.querySelector(
      '.shopify-section-header-sticky, .shopify-section-header-hidden, .header-wrapper'
    );
    var headerOffset = stickyHeader ? stickyHeader.getBoundingClientRect().height : 0;
    var prefersReducedMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 16;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  }

  function requestReviewScroll() {
    reviewScrollRequested = true;
    if (reviewScrollFrame) window.cancelAnimationFrame(reviewScrollFrame);
    reviewScrollFrame = window.requestAnimationFrame(function () {
      reviewScrollFrame = window.requestAnimationFrame(function () {
        reviewScrollFrame = null;
        scrollToReviews();
      });
    });
  }

  function settleReviewScroll() {
    if (!reviewScrollRequested) return;
    if (reviewScrollSettleTimer) window.clearTimeout(reviewScrollSettleTimer);
    reviewScrollSettleTimer = window.setTimeout(function () {
      reviewScrollSettleTimer = null;
      scrollToReviews();
      reviewScrollRequested = false;
    }, 500);
  }

  function init(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll
      ? scope.querySelectorAll('[data-eyesnug-deferred-review-widget]:not([data-eyesnug-review-observed])')
      : [];

    if (!containers.length) return;

    if (!('IntersectionObserver' in window)) {
      containers.forEach(activate);
      return;
    }

    containers.forEach(function (container) {
      let rootMargin = container.getAttribute('data-eyesnug-review-root-margin') || '1400px 0px';
      if (!observers[rootMargin]) {
        observers[rootMargin] = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observers[rootMargin].unobserve(entry.target);
            activate(entry.target);
          });
        }, { rootMargin: rootMargin });
      }
      container.setAttribute('data-eyesnug-review-observed', 'true');
      observers[rootMargin].observe(container);
    });
  }

  document.addEventListener('click', function (event) {
    var activationButton = event.target.closest && event.target.closest('[data-eyesnug-review-activate]');
    if (activationButton) {
      var activationContainer = activationButton.closest('[data-eyesnug-deferred-review-widget]');
      activate(activationContainer);
      return;
    }

    if (!event.target.closest ||
      !event.target.closest('.jdgm-prev-badge, .jdgm-preview-badge, [data-jdgm-preview-badge]')) return;
    activateAll();
    requestReviewScroll();
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    if (/review|judgeme/i.test(window.location.hash)) {
      activateAll();
      requestReviewScroll();
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('hashchange', function () {
    if (/review|judgeme/i.test(window.location.hash)) {
      activateAll();
      requestReviewScroll();
    }
  });

  window.EyesnugDeferredReviewWidget = {
    activate: activate,
    activateAll: activateAll,
    init: init,
    scrollToReviews: scrollToReviews
  };
})();
